import { ROOT_SERVER_URL } from '../config';
import { request } from '../utils';

export type CloudfrontBucketsConfig = {
  buckets: string[];
  updatedAt: string | null;
  updatedByDisplayName: string | null;
};

export function getCloudfrontEnabledBuckets(): Promise<CloudfrontBucketsConfig> {
  return request(`${ROOT_SERVER_URL}/api/app-config/cloudfront-buckets`);
}

export function addCloudfrontEnabledBucket(bucket: string): Promise<CloudfrontBucketsConfig> {
  return request(`${ROOT_SERVER_URL}/api/app-config/cloudfront-buckets`, {
    data: { bucket },
    method: 'POST',
  });
}

export function removeCloudfrontEnabledBucket(bucket: string): Promise<CloudfrontBucketsConfig> {
  return request(`${ROOT_SERVER_URL}/api/app-config/cloudfront-buckets/${encodeURIComponent(bucket)}`, {
    method: 'DELETE',
  });
}
